export type WhiteCard = { id: string; kind: "white"; text: string };
export type UnoKind = "reverse" | "skip" | "wild" | "draw2";
export type UnoCard = { id: string; kind: "uno"; uno: UnoKind };
export type PlayCard = WhiteCard | UnoCard;
export type PromptCard = { id: string; text: string };

export const PROMPTS: string[] = [
  "Nothing says Family HQ like ____.",
  "Grandma’s secret ingredient is ____.",
  "The group chat went silent after someone posted ____.",
  "Family HQ runs entirely on ____.",
  "I would trade the Sunday sauce for ____.",
  "The family motto, unfortunately, is ____.",
  "Whoever controls the aux cord must swear an oath to ____.",
  "Dad’s DJ name is now ____.",
  "The dog has been promoted to ____.",
  "In the fridge, behind the pickles, we found ____.",
  "The school talent show was ruined by ____.",
  "Our holiday photo would be perfect except for ____.",
  "The only thing wilder than Uncle’s stories is ____.",
  "Please welcome to the karaoke stage: ____.",
  "The board game night ended because of ____.",
  "Mom said we could keep it if it was ____.",
  "A true family legend never leaves HQ without ____.",
  "The neighbors knocked because they heard ____.",
  "I packed the minivan with snacks and ____.",
  "The family heirloom is secretly ____.",
  "When the power went out, we survived on ____.",
  "The baby’s first word was, regrettably, ____.",
  "This year’s yard sale featured ____.",
  "The GPS kept saying ‘recalculating’ after ____.",
  "We do not talk about ____ at dinner.",
  "The couch remembers ____.",
  "For the talent portion, I will perform ____.",
  "The lost remote was inside ____.",
  "Our family crest should really be ____.",
  "The last text in the HQ chat was just ____.",
];

export const WHITES: string[] = [
  "a slow cooker full of feelings",
  "Dad’s leftover chili from 2019",
  "the cousin who is technically forty",
  "a casserole that knows too much",
  "the honorary family dog on payroll",
  "pass-the-aux diplomacy",
  "Grandma’s gossip network",
  "a minivan with a secret identity",
  "the good scissors we are not allowed to use",
  "a juice box with unearned confidence",
  "Uncle’s mysterious ‘business’",
  "the Christmas lights from 2004, still tangled",
  "a group chat named ‘DO NOT MUTE’",
  "meatloaf so dense it has its own gravity",
  "the one folding chair that bites",
  "a polite amount of chaos",
  "Mom’s ‘we have food at home’ speech",
  "the salsa that is secretly just ketchup",
  "two left-handed oven mitts",
  "a talent for disappearing when dishes appear",
  "the family spreadsheet of grudges",
  "karaoke but make it whispered",
  "a inflatable flamingo in the living room",
  "the last mozzarella stick",
  "a board game with missing pieces and trust issues",
  "the couch cushion vault of change",
  "Dad explaining a movie you already saw",
  "sparkling water that thinks it’s fancy",
  "the cousin who brought a PowerPoint",
  "a polite pirate voice",
  "the smoke alarm as a kitchen timer",
  "matching pajamas, emotionally",
  "a recipe that begins with ‘open a can’",
  "the dog’s legal team",
  "an unattended crockpot",
  "the Bluetooth speaker nobody can connect",
  "a hug that lasts one business day",
  "the Wi-Fi password written on the fridge in runes",
  "a slide show titled ‘Vacation (Again)’",
  "the good plates, deployed in error",
  "a neighborhood watch but for snacks",
  "the baby, but with a tiny briefcase",
  "leftover birthday cake for breakfast",
  "a family vote that nobody counted",
  "the porch light that knows too much",
  "a suspiciously damp board game box",
  "Uncle’s guitar solo at 11pm",
  "the shared Netflix profile wars",
  "a coupon for one (1) apology",
  "the sauce that must never be questioned",
  "a lawn flamingo with a union card",
  "the phrase ‘we’ll see’ meaning no",
  "a road trip playlist of commercials",
  "the attic energy",
  "a high-five that missed",
  "the relative who says ‘back in my day’ about Wi-Fi",
  "a rubber chicken of peace",
  "the last clean spoon",
  "a secret handshake involving gravy",
  "the thermostat wars of ‘22",
  "a very official clipboard",
  "the smell of a just-opened pizza box",
  "a pirate map to the bathroom",
  "the family group photo where someone blinked",
  "a kazoo solo, regrettably",
  "the sacred leftover container",
  "a hamster with a business plan",
  "the phrase ‘quick stop’ that lasted two hours",
  "a glitter incident",
  "the dog interpreting the vibe",
  "a folding table of destiny",
  "Mom’s sixth sense for spilled juice",
  "a tiny cowboy hat on the remote",
  "the cousin’s magic trick that is just hiding bread",
  "a nap disguised as ‘resting my eyes’",
  "the good marker vs the sad marker",
  "a toast to the lost sock",
  "the neighborhood ice cream truck, but it’s Uncle",
  "a family slogan nobody agreed to",
  "the weird family in all of us",
];

export const UNO_LABEL: Record<UnoKind, string> = {
  reverse: "REVERSE",
  skip: "SKIP",
  wild: "WILD",
  draw2: "+2",
};

